module.exports = __webpack_public_path__ + "img/backtop.853bc49c.png";